import React, { useState } from "react";

import SavingsIcon from "@mui/icons-material/Savings";

import PercentIcon from "@mui/icons-material/Percent";

import DescriptionIcon from "@mui/icons-material/Description";

import LocalMallIcon from "@mui/icons-material/LocalMall";

import { budgetPlanningTrackerStyle } from "../css/styles/componentStyles";

import SyncAltIcon from "@mui/icons-material/SyncAlt";

import AddIcon from "@mui/icons-material/Add";



import "../css/classes/index.css";
import "../css/classes/budgetPlanningTracker.css";

import AddProductSidebar from "./addProduct/AddProductSidebar";



export default function BudgetPlanningTracker({ refreshApi }) {

  const [budgetItems] = useState([

    {

      id: "expenses",

      title: "Expenses",

      percentage: 55.1,

      icon: <LocalMallIcon size={24} style={{ color: "#d10000" }} />,

      color: "#d10000",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "bills",

      title: "Bills",

      percentage: 1.6,

      icon: <DescriptionIcon size={24} style={{ color: "#00a0c6" }} />,

      color: "#00a0c6",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "debts",

      title: "Debts",

      percentage: 8.0,

      icon: <PercentIcon size={24} style={{ color: "#0066cc" }} />,

      color: "#0066cc",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "savings",

      title: "Savings",

      percentage: 35.3,

      icon: <SavingsIcon size={24} style={{ color: "#9c27b0" }} />,

      color: "#9c27b0",

      bgColor: "#fff",

      textColor: "#333",

    },

  ]);



  const remainingPercentage = 0.0;



  return (

    <div style={{ padding: "0 90px", margin: 0, width: "100%" }}>

      <div

        className="row "

        style={{

          display: "flex",

          justifyContent: "space-between",

          flexWrap: "wrap",

          alignItems: "stretch",

        }}

      >

        <div className="col-12" style={{ marginBottom: "12px" }}></div>



        <div className="custom-col-md-2 col-6" style={{ marginBottom: "6px" }}>

          <div

            className="card "

            style={{

              ...budgetPlanningTrackerStyle.budgetPlanningTab,

              color: "#fff",

              border: "0",

              height: "100%",

            }}

          >

            <div

              className="card-body"

              style={{ padding: "10px", textAlign: "left" }}

            >

              <div

                style={{

                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "start",

                }}

              >

                <div style={{ textAlign: "left" }}>

                  <h5

                    style={{

                      fontSize: "12px",

                      fontWeight: "700",

                      marginBottom: "0",

                    }}

                  >

                    Budget Planning (%)

                  </h5>

                  <h3

                    className="display-12"

                    style={{

                      color: "#198754",

                      fontWeight: "700",

                      margin: "4px 0 2px 0",

                      fontSize: "28px",

                    }}

                  >

                    {remainingPercentage.toFixed(1)}%

                  </h3>

                  <p

                    style={{

                      color: "#fff",

                      marginBottom: "0",

                      fontSize: "12px",

                    }}

                  >

                    To be Allocated

                  </p>

                </div>

                <div

                  className=""

                  style={{ display: "flex", alignItems: "start" }}

                >

                  <SyncAltIcon style={{ color: "#fff" }} size={15} />

                </div>

              </div>

            </div>

          </div>

        </div>

        <div style={{ width: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="hide-custom">

          <AddIcon style={{ color: "#212529" }} />

        </div>



        {budgetItems.map((item, index) => (

          <>

            <div

              className="custom-col-md-2 col-6"

              key={item.id}

              style={{ marginBottom: "6px", height: "100%" }}

            >

              <div

                className="card shadow budget-planning-tracker-card"

              >

                <div

                  className="card-body"

                  style={{ padding: "6px", textAlign: "left" }}

                >

                  <div

                    style={{

                      display: "flex",

                      alignItems: "center",

                      marginBottom: "12px",

                    }}

                  >

                    <div style={{ marginRight: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: "48px", height: "48px", borderRadius: "14px", background: "linear-gradient(145deg, #ffffff, #f0f0f3)", borderTop: "1px solid rgba(255, 255, 255, 1)", boxShadow: "inset 0 1px 2px rgba(255, 255, 255, 0.5), 0 4px 10px rgba(0, 0, 0, 0.03)" }}>{React.cloneElement(item.icon, { size: 24, style: { color: item.color } })}</div>

                    <h6

                      style={{

                        fontSize: "12px",

                        fontWeight: "700",

                        marginBottom: "0",

                      }}

                    >

                      {item.title}

                    </h6>

                  </div>

                  <div

                    style={{

                      display: "flex",

                      justifyContent: "space-between",

                      alignItems: "center",

                    }}

                  >

                    <h5

                      style={{

                        fontWeight: "700",

                        marginBottom: "0",

                        fontSize: "18px",

                        letterSpacing: "-0.03em",

                      }}

                    >

                      {item.percentage.toFixed(1)}%

                    </h5>

                    {/* {index < budgetItems.length - 1 && (

                    <div className="text-muted fs-3 fw-light">+</div>

                  )} */}

                  </div>

                  <p

                    className="text-muted"

                    style={{ fontSize: "11px", marginBottom: "0", color: "#64748b" }}

                  >

                    of your income

                  </p>

                </div>

              </div>

            </div>

            {index !== budgetItems.length - 1 && (

              <div style={{ width: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="hide-custom">

                <AddIcon style={{ color: "#212529" }} />

              </div>

            )}

          </>

        ))}

      </div>

    </div>

  );

}

